// extracted by mini-css-extract-plugin
module.exports = {"hideTokensHeader":"styles_hideTokensHeader__YCMjB","wrapper":"styles_wrapper__m_Oq4","cancelButton":"styles_cancelButton__OqvPe","applyButton":"styles_applyButton__4j2cs"};